var windowLocation = window.location

module.exports = {
  hosts: {
    baseUrl: windowLocation.protocol + '//' + windowLocation.host,
    baseUrlSecure: 'https://' + windowLocation.host,
  },
  services: {
    cart: {
      uri: 'pws/v0/cart',
      timeout: 5000,
      secure: false,
    },
    protection: {
      uri: 'pws/v0/protection',
      timeout: 5000,
      secure: true,
    },
    protectionV2: {
      uri: 'pws/v2/protection',
      timeout: 5000,
      secure: true,
    },
    acePlatform: {
      uri: 'ics/v0/emcsvcs',
      timeout: 5000,
      secure: true,
    },
    ace: {
      uri: 'pws/v1/ace',
      timeout: 5000,
      secure: true,
    },
    'itinerary-service': {
      uri: 'pws/v0/itinerary-service',
      timeout: 30000,
      secure: true,
    },
    'pcln-graph': {
      uri: 'pws/v0/pcln-graph',
      timeout: 30000,
      secure: true,
    },
    'help-service': {
      uri: 'pws/v0/help-service',
      timeout: 5000,
      secure: true,
    },
  },
}
